import React, { useEffect } from "react";
import { X } from "lucide-react";

function getEmbedUrl(url) {
  const s = String(url || "");
  // YouTube (youtu.be/ID, youtube.com/watch?v=ID, youtube.com/shorts/ID)
  const yt = s.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{6,})/);
  if (yt) return { platform: "youtube", src: `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0` };
  // Vimeo
  const vm = s.match(/vimeo\.com\/(\d+)/);
  if (vm) return { platform: "vimeo", src: `https://player.vimeo.com/video/${vm[1]}?autoplay=1&title=0&byline=0&portrait=0` };
  return null;
}

export default function VideoModal({ open, onClose, url, title }) {
  useEffect(() => {
    if (!open) return;
    // Al abrir modal, pausar cualquier otro medio en la página
    window.dispatchEvent(new CustomEvent("kilombo:media-play", { detail: "video-modal" }));
    document.querySelectorAll("iframe").forEach((f) => {
      try {
        // No pausar el iframe del propio modal (aún no montado en este tick)
        if (/vimeo\.com/.test(f.src)) f.contentWindow.postMessage('{"method":"pause"}', "*");
        else if (/youtube/.test(f.src)) f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
      } catch (_) {}
    });
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;
  const embed = getEmbedUrl(url);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-8">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-5xl">
        <button
          onClick={onClose}
          aria-label="Cerrar"
          className="absolute -top-12 right-0 md:-right-2 inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors"
        >
          <span className="font-mono-caps text-xs tracking-[0.2em] uppercase hidden md:inline">Cerrar</span>
          <span className="w-9 h-9 rounded-full border border-white/25 hover:border-white flex items-center justify-center">
            <X className="w-4 h-4" />
          </span>
        </button>
        <div className="relative aspect-video w-full rounded-xl overflow-hidden bg-black border border-white/10 shadow-2xl">
          {embed ? (
            <iframe
              src={embed.src}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
              allowFullScreen
              title={title || "Video"}
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center text-white/60">Video no disponible</div>
          )}
        </div>
        {title && <p className="mt-4 text-center font-mono-caps text-xs tracking-[0.2em] uppercase text-white/60">{title}</p>}
      </div>
    </div>
  );
}
